/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AgentChat extends models.AgentFieldsBase {
    getFixupPrototypeFunction() { return AgentChat.fixupPrototype; }

    static newInstance(model: Partial<AgentChat>): AgentChat {
        let obj = Object.assign(new AgentChat(), model);
        AgentChat.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AgentChat>): AgentChat {
        if (!model) return null;
        return AgentChat.newInstance(<AgentChat> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AgentChat) {
        if (!obj) return;

        models.AgentChat.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AgentChat): boolean {
        if (models.AgentFieldsBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, AgentChat.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
        if (this.metadata) {
            models.ChatMetadata.fixupPrototype(this.metadata);
        }
        if (this.participants) {
            for (let val of this.participants) {
                models.AgentChatParticipant.fixupPrototype(val);
            }
        }
    }

    /**
     * Name of the chat
     */
    name: string;

    /**
     * Name of the user who created the chat.
     */
    created_by: string;

    /**
     * ID of the agent
     */
    agent_id: string;

    /**
     * ID of the tenant
     */
    tenant_id: string;

    /**
     * ID of the user who owns the chat
     */
    owner_id: string;

    /**
     * IDs of the users the chat is shared with
     */
    shared_with: Array<string>;

    /**
     * Owner and shared users of the chat, resolved to names and emails
     */
    participants: Array<models.AgentChatParticipant>;

    /**
     * Whether the caller holds the share-chat capability (users/read via a DEFAULT role in this chat's tenant). This alone never authorizes sharing - only the chat's owner may share, enforced separately; for non-owners it only unlocks seeing the member roster. Computed per request; never stored.
     */
    viewer_share_capability: boolean;

    /**
     * Metadata for the chat
     */
    metadata: models.ChatMetadata;

}
